(function () {
  'use strict';

  var STORAGE_KEY = 'assistco_brand_agent_used';
  var seen = Object.create(null);

  function clarityReady() {
    return typeof window.clarity === 'function';
  }

  function sendClarityEvent(name) {
    if (!name || seen[name]) return;

    if (!clarityReady()) {
      setTimeout(function () {
        if (clarityReady()) sendClarityEvent(name);
      }, 600);
      return;
    }

    seen[name] = true;

    try {
      window.clarity('event', name);
      window.clarity('set', 'brand_agent_session', 'true');
      window.clarity('upgrade', 'brand agent interaction');
    } catch (e) {}
  }

  function markUsed(eventName) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
    sendClarityEvent(eventName || 'brand_agent_interaction');
  }

  function hasUsedBrandAgent() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function textLooksLikeBrandAgent(value) {
    value = String(value || '').toLowerCase();
    return (
      value.indexOf('brandagent') !== -1 ||
      value.indexOf('brand-agent') !== -1 ||
      value.indexOf('brand agent') !== -1 ||
      value.indexOf('clarity') !== -1 ||
      value.indexOf('chat') !== -1 ||
      value.indexOf('assistant') !== -1 ||
      value.indexOf('agent') !== -1
    );
  }

  function elementLooksLikeBrandAgent(element) {
    if (!element || element.nodeType !== 1) return false;

    var attrs = [
      element.id,
      element.className,
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('role'),
      element.getAttribute('src'),
      element.getAttribute('href'),
      element.getAttribute('data-testid'),
      element.getAttribute('data-clarity-id')
    ];

    return attrs.some(textLooksLikeBrandAgent);
  }

  function closestBrandAgentElement(target) {
    var element = target && target.nodeType === 1 ? target : target && target.parentElement;
    var depth = 0;

    while (element && depth < 8) {
      if (elementLooksLikeBrandAgent(element)) return element;
      element = element.parentElement;
      depth += 1;
    }

    return null;
  }

  function inspectNode(node) {
    if (!node || node.nodeType !== 1) return;

    if (elementLooksLikeBrandAgent(node)) {
      sendClarityEvent('brand_agent_widget_loaded');
    }

    if (node.querySelectorAll) {
      var candidates = node.querySelectorAll(
        'iframe, button, [role="button"], [aria-label], [class*="clarity"], [id*="clarity"], [class*="chat"], [id*="chat"], [class*="agent"], [id*="agent"]'
      );

      for (var i = 0; i < candidates.length; i += 1) {
        if (elementLooksLikeBrandAgent(candidates[i])) {
          sendClarityEvent('brand_agent_widget_loaded');
          break;
        }
      }
    }
  }

  function trackClicks() {
    document.addEventListener(
      'click',
      function (event) {
        var brandAgentElement = closestBrandAgentElement(event.target);
        if (brandAgentElement) {
          markUsed('brand_agent_clicked');
          return;
        }

        if (!hasUsedBrandAgent()) return;

        var target = event.target && event.target.closest ? event.target.closest('button, a, [role="button"]') : null;
        if (!target) return;

        var label = [
          target.getAttribute('name'),
          target.getAttribute('aria-label'),
          target.getAttribute('data-action'),
          target.textContent
        ]
          .join(' ')
          .toLowerCase();

        if (
          label.indexOf('add') !== -1 ||
          label.indexOf('legg') !== -1 ||
          label.indexOf('cart') !== -1 ||
          label.indexOf('handlekurv') !== -1 ||
          label.indexOf('checkout') !== -1 ||
          label.indexOf('kasse') !== -1
        ) {
          sendClarityEvent('brand_agent_after_commerce_click');
        }
      },
      true
    );
  }

  function trackForms() {
    document.addEventListener(
      'submit',
      function (event) {
        if (!hasUsedBrandAgent()) return;
        var form = event.target;
        var action = form && form.getAttribute ? String(form.getAttribute('action') || '').toLowerCase() : '';
        if (action.indexOf('/cart/add') !== -1 || action.indexOf('/checkout') !== -1 || action.indexOf('/contact') !== -1) {
          sendClarityEvent('brand_agent_after_form_submit');
        }
      },
      true
    );
  }

  function observeWidget() {
    inspectNode(document.documentElement);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(inspectNode);
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function setPageTags() {
    if (!clarityReady()) {
      setTimeout(setPageTags, 600);
      return;
    }

    try {
      window.clarity('set', 'shopify_page_type', document.body.className || 'unknown');
      window.clarity('set', 'site_host', window.location.hostname);
    } catch (e) {}
  }

  function init() {
    setPageTags();
    trackClicks();
    trackForms();
    observeWidget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
